<!-- eslint-disable no-nested-ternary -->
<script>
import { defineComponent, reactive, ref, toRefs, watchEffect } from '@vue/composition-api';
import { getUserButtonList } from '../smartWiring/api';

export default defineComponent({
    name: 'NavMenu',
    emits: ['on-switch-tabs'],
    setup(_, { emit, root }) {
        const variables = reactive({
            activeKey: ref('1'),
            lineOrSiteTitle: ref('线路报价'),
            hasLineQuotation: ref(true), // 是否有线路报价权限
            hasEmailManage: ref(false) // 是否有邮件管理权限
        });

        const handleTabsChange = (val) => {
            variables.activeKey = val;
            const componentType = val === '1' ? 'SmartWiring' : val === '3' ? 'EmailManage' : variables.lineOrSiteTitle === '线路报价' ? 'LineList' : 'StationList';
            emit('on-switch-tabs', componentType);
        };

        const handleClickMenu = (val) => {
            variables.lineOrSiteTitle = val.key;
            handleTabsChange('2');
        };

        const { accountId, customerId } = root.$route.query;

        const getPermissionParams = () => ({
            accountId: accountId || '',
            objId: customerId || '',
            admin: false,
            functionTypes: ['MODULE', 'MENU', 'BUTTON'],
            status: 'ENABLED',
            systemCode: 'customer'
        });

        // 获取模块权限
        const getButtonList = async () => {
            const params = getPermissionParams();
            const res = await getUserButtonList(params);
            const buttonPermission = res || [];
            variables.hasLineQuotation = buttonPermission.length ? buttonPermission.some((v) => v.uri === 'line-upkeep-quotation') : true;
            variables.hasEmailManage = buttonPermission.length ? buttonPermission.some((v) => v.uri === 'email-manage') : true;
            // variables.hasLineQuotation = true
            // variables.hasEmailManage = true
        };

        watchEffect(() => {
            // getButtonList();
        });

        return {
            ...toRefs(variables),
            handleTabsChange,
            handleClickMenu
        };
    }
});
</script>

<template>
    <div class="nav-menu">
        <a-tabs type="card" :tab-bar-gutter="0" :active-key="activeKey" @change="handleTabsChange">
            <a-tab-pane key="1" tab="计划单排线"></a-tab-pane>
            <a-tab-pane v-if="hasLineQuotation" key="2">
                <a-dropdown slot="tab">
                    <span> <a-icon type="down" /> {{ lineOrSiteTitle }} </span>
                    <a-menu slot="overlay" @click="handleClickMenu">
                        <a-menu-item key="线路报价">线路报价</a-menu-item>
                        <!-- <a-menu-item key="站点信息">站点信息</a-menu-item> -->
                    </a-menu>
                </a-dropdown>
            </a-tab-pane>
            <a-tab-pane v-if="hasEmailManage" key="3" tab="邮件管理"></a-tab-pane>
        </a-tabs>
    </div>
</template>

<style lang="less" scoped>
/deep/.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    border-radius: 0;
}

/deep/.ant-tabs-bar {
    margin: 0;
}
</style>
